/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pdf_Cv_Review_Category_ScoresInputs */

const en_pdf_cv_review_category_scores = /** @type {(inputs: Pdf_Cv_Review_Category_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Category Scores`)
};

const de_pdf_cv_review_category_scores = /** @type {(inputs: Pdf_Cv_Review_Category_ScoresInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewertung nach Kategorien`)
};

/**
* | output |
* | --- |
* | "Category Scores" |
*
* @param {Pdf_Cv_Review_Category_ScoresInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pdf_cv_review_category_scores = /** @type {((inputs?: Pdf_Cv_Review_Category_ScoresInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pdf_Cv_Review_Category_ScoresInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pdf_cv_review_category_scores(inputs)
	return en_pdf_cv_review_category_scores(inputs)
});